import React from 'react';
import { Button } from 'antd';
import './ArrowButton.css';
import { getIcon, ICONS } from '../../icons';
import { COLOURS } from '../../colours';

const ArrowButton = ({
  children,
  variant = 'blue',
  position = 'right',
  icon = ICONS.ARROW_UP_RIGHT,
  size = 'md',
  className = '',
  ...rest
}) => {
  const isWhite = variant === 'white';
  const isHero = variant === 'hero';
  const pillClass = [
    'arrow-btn',
    `arrow-btn--${variant}`,
    `arrow-btn--${size}`,
    className
  ].join(' ');

  return (
    <Button type="primary" className={pillClass} {...rest}>
      { position === "left" && <span className="arrow-btn__icon left">
        { getIcon(icon, true, { 
          secondaryOpacity: 1, 
          primary : (isWhite || isHero) ? 'white' : COLOURS.PRIMARY,
          secondary : (isWhite || isHero) ? 'white' : COLOURS.PRIMARY,
        } )} </span> }
      <span className="arrow-btn__text">{children}</span>
      { position === "right" && <span className="arrow-btn__icon">
        { getIcon(icon, true, { 
          secondaryOpacity: 1, 
          primary : (isWhite || isHero) ? 'white' : COLOURS.PRIMARY,
          secondary : (isWhite || isHero) ? 'white' : COLOURS.PRIMARY,
        } )} </span> }
    </Button>
  );
};

export default ArrowButton;
